import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
// Layout & Pages
import Layout from "./Components/Sidebar/Layout";
import Dashboard from "./Components/Dashboard/index";
import Donors from "./Components/Donors/index";
import Volunteers from "./Components/Volunteers/index";
import CausesEvents from "./Components/CausesEvents/index";
import CMSPages from "./Components/CMSPages/index";
import Gallery from "./Components/Gallery/index";
import Reports from "./Components/Reports/index";
import Volunteer from "./Components/Volunteer/volunteer";
import Donations from "./Components/Donations";
import OurEventsSlider from "./Components/OurEventsSlider";
import TermsEditor from "./Components/TermsConditions";
import PrivacyPolicy from "./Components/Privacypolicy/Privacypolic";
import Refundpolicy from "./Components/Refundpolicy/refundpolicy";
// Auth Component
import AuthForm from "./Components/authForm";
function App() {
  const [themeMode, setThemeMode] = React.useState("light");
  const theme = createTheme({
    palette: {
      mode: themeMode,
      primary: {
        main: "#6366F1",
      },
      secondary: {
        main: "#10B981",
      },
      background: {
        default: themeMode === "light" ? "#F9FAFB" : "#121212",
        paper: themeMode === "light" ? "#FFFFFF" : "#1E1E1E",
      },
    },
    shape: {
      borderRadius: 16,
    },
    typography: {
      fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    },
  });
  const toggleTheme = () => {
    setThemeMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
  };
  const isAuthenticated = !!localStorage.getItem("authToken");
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Public Auth Route */}
          <Route path="/auth" element={<AuthForm />} />
          {/* Protected Routes */}
          <Route
            path="/*"
            element={
              isAuthenticated ? (
                <Layout toggleTheme={toggleTheme} themeMode={themeMode}>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/donors" element={<Donors />} />
                    <Route path="/volunteers" element={<Volunteers />} />
                    <Route path="/volunteer" element={<Volunteer />} />
                    <Route path="/causes" element={<CausesEvents />} />
                    <Route path="/donations" element={<Donations />} />
                    <Route path="/cms" element={<CMSPages />} />
                    <Route path="/gallery" element={<Gallery />} />
                    <Route path="/reports" element={<Reports />} />
                    <Route
                      path="/our-events-slider"
                      element={<OurEventsSlider />}
                    />
                    <Route path="/termscondition" element={<TermsEditor />} />
                    <Route path="/refundpolicy" element={<Refundpolicy />} />
                    <Route path="/privacypolicy" element={<PrivacyPolicy/>}/>
                    <Route path="*" element={<Navigate to="/" />} />
                  </Routes>
                </Layout>
              ) : (
                <Navigate to="/auth" replace />
              )
            }
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}
export default App;
